/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 * Table constants
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Julia Ignatieva
 * @author Evgeniy Naumov
 * @author Nikolay Sviridov
 * @version 1.36.1
 * @since 1.0.0
 */

import { SagaIterator } from 'redux-saga';

import { labelsImportLoadValidatedListSaga } from '@/main/pages/PageLabelsImport/labelsImportSagas';
import { importPersonalDataLoadListSaga } from '@/main/pages/WizardImportPersonalData/wizardImportPersonalDataSagas';
import { importSubscribersLimitsLoadListSaga } from '@/main/pages/WizardImportSubscribersLimits/wizardImportSubscribersLimitsSagas';
import { productSubscribersGetListSaga } from '@/main/pages/WizardProductOfferings/wizardProductOfferingsStepSelectSubscribersSaga';
import { RoutePath } from '@/main/routes/constants/routesConstants';

import { TableNameType } from '../types/tableTypes';

export enum EFastWizardType {
    WIZARD_BILLS_DOCS = 'WIZARD_BILLS_DOCS',
    WIZARD_REPORT_DOCS = 'WIZARD_REPORT_DOCS',
}

export enum EFastBasketSwitchboxContext {
    WIZARD_BILLS_DOCS = 'WIZARD_BILLS_DOCS',
    MAIN_OPERATIONS = 'MAIN_OPERATIONS',
}

export const fastActionRoutes = 
    [
        RoutePath.fastAdvanceInvoice, 
        RoutePath.fastInquiryCreate, 
        RoutePath.fastPromisedPayment,
        RoutePath.wizardFastBillsDoc,
        RoutePath.wizardFastReportDoc,
    ];

export const fastBasketPages = 
    [
        RoutePath.fastAdvanceInvoice, 
        RoutePath.fastInquiryCreate, 
        RoutePath.fastPromisedPayment,
    ];

export const CHECKED_COLUMN_NAME = 'checked';
export const TABLE_WIDTH_MAX = 440;
export const TABLE_WIDTH_MIN = 120;
export const TABLE_LOAD_SIZE = 24;
export const TABLE_DENSITY_LOAD_SIZE = 32;
export const TABLE_FOOTER_BOTTOM_STYLE = 33;
export const TABLE_FOOTER_OPEN_BOTTOM_STYLE = 81;
export const MB = 1048576; // 1024 * 1024 = 1048576 (1MB);
export const MAX_FILE_SIZE_MB = 10; // max attachment file size
export const DEFAULT_MAX_FILE_SIZE = MAX_FILE_SIZE_MB * MB;

export const TableWithLabels = [
    TableNameType.productSelectSubscribers,
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapTableWithOwnSaga: { [key in TableNameType]?: (action: any) => SagaIterator } = {
    [TableNameType.importPersonalData]: importPersonalDataLoadListSaga,
    [TableNameType.labelsImport]: labelsImportLoadValidatedListSaga,
    [TableNameType.productSelectSubscribers]: productSubscribersGetListSaga,
    [TableNameType.importSubscribersLimits]: importSubscribersLimitsLoadListSaga,
}
